import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/delicious': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.5 68c1 3.8 1.5 7.9 1.6 12v352.1c0 26.5-21.5 48-48 48h-352c-4.1 0-8.2-0.5-12-1.5-7.7-2-14.6-5.8-20.3-11-1.2-1.1-2.3-2.2-3.3-3.3-5.2-5.7-9-12.6-11-20.3-1-3.8-1.5-7.9-1.5-12v-352c0-26.5 21.5-48 48-47.9h352c4.1 0 8.2 0.5 12 1.5 1.9 0.4 3.7 1 5.4 1.7 1.9 0.7 3.7 1.5 5.5 2.5 1.4 0.7 2.7 1.5 4 2.4 1.1 0.8 2.2 1.6 3.3 2.5 2.5 2 4.8 4.3 6.9 6.8 1.7 2.1 3.3 4.5 4.7 6.9 1.3 2.3 2.4 4.6 3.3 7.1 0.5 1.5 1 3 1.4 4.5zM416 432v-176h-192v-192h-176c-8.8 0-16 7.2-16 16v176h192v192h176c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/delicious.js
// module id = 787
// module chunks = 0